import $ from 'jquery';

window.jQuery = window.$ = $;

export default $;
